module.exports = __webpack_public_path__ + "img/no-notifications-box.e008a443.svg";